import {createSlice} from '@reduxjs/toolkit';

const fiberProductCardSlice = createSlice({
  name: 'fiberProductCard',
  initialState: {
    fiberProductId: '',
    isSelectedBtn: false,
    packageIndex: '',
  },

  reducers: {
    setFiberPackageCode: {
      reducer(state, action) {
        if (state.isSelectedBtn && state.packageIndex == action.payload.packageIndex) {
          state.isSelectedBtn = false;
        } else {
          state.isSelectedBtn = true;
        }
        state.fiberProductId = action.payload.fiberProdId;
        state.packageIndex = action.payload.packageIndex;
      },
    },
  },
});

export const {setFiberPackageCode} = fiberProductCardSlice.actions;
export default fiberProductCardSlice.reducer;
